<template>
  <div class="main-r-wrap">
    <div class="main-r-top">
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'online' && 'active'"
        @click.stop="handleClick('online')"
      >{{$t('apiDoc.在线文档')}}</span>
      <span
        class="main-r_top_nav"
        :class="mainStatus === 'apiTest' && 'active'"
        @click.stop="handleClick('apiTest')"
      >{{$t('apiDoc.测试工具')}}</span>
    </div>
    <!-- 在线文档 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'online'">
      <online-doc :onlineData="onlineData"></online-doc>
    </div>
    <!-- 在线文档 END -->
    <!-- 测试工具 START -->
    <div class="main-r-bottom" v-show="mainStatus === 'apiTest'">
      <api-test-doc :apiTestData="apiTestData"></api-test-doc>
    </div>
    <!-- 测试工具 END -->
  </div>
</template>

<script>
import onlineDoc from "../components/onlineDoc";

import apiTestDoc from "../components/apiTestDoc";

import {OPEN_API_TEST,OPEN_API_PRO} from '@/constants/index'

const apiUrlTest = 'logistics/trace';
export default {
  components: { onlineDoc , apiTestDoc },
  data() { 
    return {
      mainStatus: "online",
      //当前请求URL
      apiBaseUrl: process.env.VUE_APP_API_URL + `/${apiUrlTest}`,

      onlineData: {
        //接口描述
        apiDesc: `${this.$t('onlineDoc.trackDescription_1')}`,
        //接口地址
        testApi: `${OPEN_API_TEST}/${apiUrlTest}`,
        proApi: `${OPEN_API_PRO}/${apiUrlTest}`,
        //参数描述  START
       postDataList:[
            
        //   请求头参数
            {
                title:'Headers',
                value:[
                    {name: "apiAccount",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.接入方在平台的api账户标识')}`,},
                    {name: "digest",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.签名字符串')}`,},
                    {name: "timestamp",type: "Number",require: "Y",normal: "",describe: `${this.$t('onlineDoc.时间戳，毫秒')}`,},
                    ]
            },
             { 
                title:`${this.$t('onlineDoc.请求参数')}`, 
                 value:[
                    {name: "bizContent",type: "String",require: "Y",normal: `${this.$t('onlineDoc.业务参数')}`,describe: `${this.$t('onlineDoc.业务参数模块内json格式的string类型')}`,},
                ]
            },
            {
              title:`${this.$t('onlineDoc.业务参数')}`,
              value:[
                {name: "command",type: "int(5)",require: "N",normal: "0",describe: `${this.$t('onlineDoc.查询命令：（枚举）')}`},
                {name: "customerCode",type: "String",require: "C",normal: "0",describe: `${this.$t('onlineDoc.客户编码必填描述')}`},
                {name: "billCodes",type: "String",require: "N",normal: "UT0000352320970",describe: `${this.$t('onlineDoc.运单号多个运单号以英文逗号隔开,目前先支持一次性最多查询30票运单')}`},
                {name: "invoiceAccessKey",type: "String",require: "N",normal: "33240442446277000354554629302337581016930063",describe: `${this.$t('onlineDoc.发票秘钥多个发票秘钥以英文逗号隔开,目前先支持一次性最多查询30票运单')}`},
                {name: "customerOrderNumber",type: "String",require: "N",normal: "BR2455090392188U",describe: `${this.$t('onlineDoc.客户订单编号多个运以英文逗号隔开,目前先支持一次性最多查询30票运单')}`},
              ]
            }

        ],
        //参数描述  END
        //报文描述 start
        responseDataList:[
            
        //   响应参数
            {
                title:`${this.$t('onlineDoc.响应参数')}`,
                value:[
                    { name: "code",type: "String", require: "Y",normal: "",describe: `${this.$t('onlineDoc.返回码，见附录')}`,},
                    {name: "msg",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.描述')}`,},
                    {name: "data",type: "Object",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务数据')}`,},
                  ]
            },
            {
              title:`${this.$t('onlineDoc.data类型说明')}`,
              value:[
                  {name: "billCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.运单号')}`},
                  {name: "invoiceAccessKey",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.发票秘钥')}`},
                  {name: "customerOrderNumber",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.客户订单编号')}`},
                  {name: "details",type: "Array",require: "Y",normal: "",describe: `${this.$t('onlineDoc.运单轨迹详情')}`}
                ]
            },
            {
              title:`${this.$t('onlineDoc.details类型说明')}`,
              value:[
                  {name: "scanTime",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.扫描时间')}`},
                  {name: "desc",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.轨迹描述')}`},
                  {name: "scanType",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.scanType')}`},
                  {name: "scanCode",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.scanCode')}`},
                  {name: "problemType",type: "String",require: "N",normal: "",describe: `${this.$t('onlineDoc.problemType')}`},
                  {name: "scanNetworkName",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.扫描网点名称')}`},
                  {name: "scanNetworkId",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.扫描网点ID')}`},
                  {name: "staffName",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务员姓名')}`},
                  {name: "staffContact",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.业务员联系方式')}`},
                  {name: "scanNetworkContact",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.扫描网点联系方式')}`},
                  {name: "scanNetworkProvince",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.扫描网点省份')}`},
                  {name: "scanNetworkCity",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.扫描网点城市')}`},
                  {name: "scanNetworkArea",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.扫描网点区/县')}`},
                  {name: "nextStopName",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.上一站(到件)或下一站名称(发件)')}`},
                  {name: "nextNetworkProvinceName",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.下一站省份（发件扫描类型时提供）')}`},
                  {name: "nextNetworkCityName",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.下一站城市（发件扫描类型时提供）')}`},
                  {name: "nextNetworkAreaName",type: "String",require: "Y",normal: "",describe: `${this.$t('onlineDoc.下一站区/县（发件扫描类型时提供）')}`},
                  {name: "staffLng ", type: "String", require: "N", normal: "", describe: `${this.$t('onlineDoc.经度')}`},
                  {name: "staffLat", type: "String", require: "N", normal: "", describe: `${this.$t('onlineDoc.纬度')}`},
                  {name: "signer", type: "String", require: "N", normal: "", describe: `${this.$t('onlineDoc.签收人')}`},
                  {name: "signName", type: "String", require: "N", normal: "", describe: `${this.$t('onlineDoc.签收类型名称')}`},
                  {name: "signatureUrl", type: "String", require: "N", normal: "", describe: `${this.$t('onlineDoc.电子签名图片')}`},
                  {name: "sigPicUrl", type: "String", require: "N", normal: "", describe: `${this.$t('onlineDoc.签收图片')}`}
                ]
            }

        ],
        //请求示例
        requestCode: `Header：
    apiAccount=1627
    digest=U40e5sumorgd3YgZzU61Mw==
    timestamp=1565238848921

Body：
    bizContent= {
      "command": "",//非必填，空或者不存在默认为使用billcodes查询，0：billCodes/ 1: invoiceAccessKey / 2: customerOrderNumber
      "billCodes": "UT0000352320970,UT0000359748995",
      "customerCode":"J1999999",
      "invoiceAccessKey": "33240442446277000354554629302337581016930063,33240442446277000354554629302337581016930064",
      "customerOrderNumber": "BR2455090392188U,BR2455090392189U"
    }`,
        //返回示例
        responseCode: JSON.parse(`{
  "code": "1",
  "msg": "success",
  "data": [
    {
      "billCode": "UT0000352320970",
      "invoiceAccesskey": "33240442446277000354554629302337581016930063",
      "customerorderNumber": "BR2455090392188U",
      "details": [
        {
          "scanTime": "2024-04-09 07:30:33",
          "desc": "",
          "scanType": "assinatura de encomenda",
          "scanNetworkTypeName": "网点",
          "scanNetworkName": "叙中村网点",
          "scanNetworkId": 96,
          "scanNetworkProvince": "SP",
          "scanNetworkCity": "Adamantina",
          "scanNetworkArea": "Centro",
          "scanCode": 100,
          "signer": "RGM100_新一",
          "signName": "本人签收",
          "signatureUrl": "",
          "sigPicUrl": ""
        }
      ]
    },
    {
      "billCode": "UT0000359748995",
      "invoiceAccesskey": "33240442446277000354554629302337581016930064",
      "customerorderNumber": "BR2455090392189U",
      "details": [
        {
          "scanTime": "2024-04-09 07:30:33",
          "desc": "",
          "scanType": "assinatura de encomenda",
          "scanNetworkTypeName": "网点",
          "scanNetworkName": "叙中村网点",
          "scanNetworkId": 96,
          "scanNetworkProvince": "SP",
          "scanNetworkCity": "Adamantina",
          "scanNetworkArea": "Centro",
          "scanCode": 100,
          "signer": "RGM100_新一",
          "signName": "本人签收",
          "signatureUrl": "",
          "sigPicUrl": ""
        }
      ]
    }
  ]
}`),

        //错误代码提示
        errcodeJson: [{code:'145003100',msg:`${this.$t('apiTestDoc.运单号非法')}`},
          {code:'145003502',msg:`${this.$t('apiTestDoc.运单号个数超过30')}`}]
      },

      apiTestData: {
          _headerData: {
            apiAccount: "1001",
            digest: "U40e5sumorgd3YgZzU61Mw==",
            timestamp: "1565238848921",
          },
          data:{
             bizContent: `{"billCodes":"UT0000352320970,UT0000359748995,UT0000353613157"}`,
          },
        //必须要验证的参数
        requestData:['apiAccount','digest','timestamp','bizContent'],
        textareaData:{
          bizContent:true
        },
        //促发接口
        apiUrl: `/mock/${apiUrlTest}`,
        //返回
        ResponseJson: "",
        //当前请求URL
        apiBaseUrl: process.env.VUE_APP_API_URL + `/mock/${apiUrlTest}`,
        //错误代码提示
        errcodeJson: [{code:'145003100',msg:`${this.$t('apiTestDoc.运单号非法')}`},
          {code:'145003502',msg:`${this.$t('apiTestDoc.运单号个数超过30')}`}]
      },
    };
  },
  created() {},
  methods: {
    handleClick(status) {
      this.mainStatus = status;
    }
  },
};
</script>

<style lang="scss" scoped>
@import "../../css/apiTest.scss";
</style>